import React, { memo } from 'react';
export const FAQ = () => {
  return <section className="text-lg md:text-xl text-gray-800 mb-12 leading-relaxed space-y-6 border-t border-gray-200 pt-10" data-id="element-61" data-mp="ik57hr6v1zs4">
      <h2 className="font-bold text-2xl md:text-3xl mb-6 text-gray-900" data-id="element-62" data-mp="1hdkvam3dmfzt">
        Frequently Asked Questions
      </h2>

      <div className="space-y-6" data-id="element-63" data-mp="1cf057fhu9cp3">
        <div data-id="element-64" data-mp="1cft6i0y139zu">
          <h4 className="font-bold text-lg text-gray-900 m-0" data-id="element-65" data-mp="1cgb719rq4adk">
            Is{' '}
            <a href="#offer" className="text-blue-700 underline font-bold" data-id="element-66" data-mp="2a1qg18ufk4zn">
              VelaSleep
            </a>{' '}
            good for side sleepers?
          </h4>
          <p className="mt-1" data-id="element-67" data-mp="2039n46bxlgay">
            Yes. The contour design was created to support both side and back
            sleeping positions.
          </p>
        </div>
        <div data-id="element-68" data-mp="oow1z98kbeym">
          <h4 className="font-bold text-lg text-gray-900 m-0" data-id="element-69" data-mp="oonrfnzwwlql">
            Will it feel different than my current pillow?
          </h4>
          <p className="mt-1" data-id="element-70" data-mp="jp1cna4fqxfo">
            Most customers notice the unique shape immediately. A short
            adjustment period is normal.
          </p>
        </div>
        <div data-id="element-71" data-mp="1pncv5p8z2ua6">
          <h4 className="font-bold text-lg text-gray-900 m-0" data-id="element-72" data-mp="1pls07yiqx9bs">
            How firm is it?
          </h4>
          <p className="mt-1" data-id="element-73" data-mp="1aor7pssqdac9">
            <a href="#offer" className="text-blue-700 underline font-bold" data-id="element-74" data-mp="1arn77lk8872t">
              VelaSleep
            </a>{' '}
            uses supportive memory foam designed to balance comfort and
            structure.
          </p>
        </div>
        <div data-id="element-75" data-mp="16oh58q45d225">
          <h4 className="font-bold text-lg text-gray-900 m-0" data-id="element-76" data-mp="16p0l81a8lgdj">
            How long does shipping take?
          </h4>
          <p className="mt-1" data-id="element-77" data-mp="s0m8myn0qdjs">
            Shipping times vary based on location and current inventory.
          </p>
        </div>
        <div data-id="element-78" data-mp="wvt5pnls8jzq">
          <h4 className="font-bold text-lg text-gray-900 m-0" data-id="element-79" data-mp="iymr8583d7gb">
            Is there a guarantee?
          </h4>
          <p className="mt-1" data-id="element-80" data-mp="n0hrd6eadesi">
            Yes. Your purchase is backed by the brand's satisfaction guarantee.
          </p>
        </div>
        <div data-id="element-81" data-mp="2po7yzl2z7cxh">
          <h4 className="font-bold text-lg text-gray-900 m-0" data-id="element-82" data-mp="2pny9rzpr99su">
            What if I've already tried other pillows?
          </h4>
          <p className="mt-1" data-id="element-83" data-mp="2fwkde0t3oq3x">
            Many customers report trying multiple pillows before discovering the
            importance of dedicated neck support.
          </p>
        </div>
      </div>
    </section>;
};